import { render } from "./UserPopupMenu.vue?vue&type=template&id=3cc7ba88&scoped=true"
import script from "./UserPopupMenu.vue?vue&type=script&lang=js"
export * from "./UserPopupMenu.vue?vue&type=script&lang=js"

import "./UserPopupMenu.vue?vue&type=style&index=0&id=3cc7ba88&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc7ba88"]])

export default __exports__